import { render, staticRenderFns } from "./SmallTextFormItem.vue?vue&type=template&id=09264fd0&scoped=true&"
import script from "./SmallTextFormItem.vue?vue&type=script&lang=js&"
export * from "./SmallTextFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09264fd0",
  null
  
)

export default component.exports